import { CatAccordion } from '@blocks-react/components/Accordion';
import { PropsWithChildren } from 'react';

export function FooterAccordion({ children }: Readonly<PropsWithChildren>) {
  return <CatAccordion inverted>{children}</CatAccordion>;
}
